export default __webpack_public_path__ + "884c4e879d2f802e976e714a3a64f0e4.svg";